import { TWITCH_PLAYER_ORIGIN } from "./player-api.js";
import { isNil, isString } from "@videojs/utils/predicate";
//#region src/source.ts
/** Extract a Twitch VOD id from any recognized video URL. */
function parseTwitchVideoId(src) {
	return parseTwitchSource(src)?.id ?? null;
}
/**
* Parse a Twitch source string. Recognizes VOD URLs (`twitch.tv/videos/<id>` and `twitch.tv/?video=<id>`) and channel
* URLs (`twitch.tv/<channel>`), with or without the `www.` and `go.` hosts, and with or without a trailing slash.
*/
function parseTwitchSource(src) {
	if (!src) return null;
	const videoId = MATCH_VIDEO.exec(src)?.[1];
	if (videoId) return {
		kind: "video",
		id: videoId,
		channel: null
	};
	const channel = MATCH_CHANNEL.exec(src)?.[1];
	if (channel) return {
		kind: "channel",
		id: null,
		channel
	};
	return null;
}
/** Build the iframe `src` URL for an initial Twitch embed from the given props. */
function buildTwitchIframeSrc(src, props = {}) {
	const parsed = parseTwitchSource(src);
	if (!parsed) return "";
	const { parent, referrerPolicy: _referrerPolicy, ...twitch } = props.source?.engine?.twitch ?? {};
	const params = {
		...parsed.kind === "video" ? { video: `v${parsed.id}` } : { channel: parsed.channel },
		controls: props.controls === true ? null : false,
		autoplay: props.autoplay === true ? null : false,
		muted: props.defaultMuted ?? false,
		preload: props.preload ?? "metadata",
		...twitch
	};
	const query = new URLSearchParams();
	for (const key in params) {
		const value = params[key];
		if (isNil(value) || value === "") continue;
		query.set(key, String(value));
	}
	for (const host of resolveParentHosts(parent)) query.append("parent", host);
	return `${TWITCH_PLAYER_ORIGIN}/?${query.toString()}`;
}
/** The configured parent hostnames plus the page's own, deduplicated. */
function resolveParentHosts(parent) {
	const hosts = [...isString(parent) ? [parent] : parent ?? [], globalThis.location?.hostname];
	return [...new Set(hosts.filter((host) => isString(host) && host !== ""))];
}
const MATCH_VIDEO = /(?:^|\/\/)(?:www\.|go\.)?twitch\.tv\/(?:videos?\/|\?video=)(\d+)\/?(?:$|\?)/;
const MATCH_CHANNEL = /(?:^|\/\/)(?:www\.|go\.)?twitch\.tv\/([a-zA-Z0-9_]+)\/?(?:$|\?)/;
//#endregion
export { buildTwitchIframeSrc, parseTwitchSource, parseTwitchVideoId };
